// extracted by mini-css-extract-plugin
export default {"selectContainer":"ProductVolumeIn_selectContainer__dlbFT","selectTitle":"ProductVolumeIn_selectTitle__E4xdy"};